module.exports = __webpack_public_path__ + "img/doctors-illustration.1bbaa5b1.png";